<ngb-pagination class="d-flex justify-content-end mt-1 me-1"
                aria-label="Default pagination"
                [maxSize]="visiblePageCount"
                [collectionSize]="pagerOptions?.total || 1"
                [page]="pagerOptions?.currentPage || 1"
                [pageSize]="pagerOptions?.pageSize || 1"
                (pageChange)="onPageChange($event)">
    <ng-template ngbPaginationPrevious><span
        [data-feather]="'chevron-left'" [size]="18" [class]="'fw-bolder'"></span>
    </ng-template>
    <ng-template ngbPaginationNext><span
            [data-feather]="'chevron-right'"
            [class]="'fw-bolder'" [size]="18"></span></ng-template>
</ngb-pagination>